module.exports = __webpack_public_path__ + "img/clipboard-list-solid.0a9414a8.svg";